/**
 * @name AddUserController
 * @description Controller to add a user
 * @param {type} $state Description
 * @param {type} $rootScope Description
 * @param {type} Collector Description
 * @param {type} Association Description
 * @param {type} Operators Description
 * @param {type} Artists Description
 * @param {type} NOTIFICATIONS Description
 * @param {type} Notification Description
 * @param {type} InvitationFactory Description
 * @param {type} moment Description
 * @param {type} AlertMessages Description
 * @param {type} Session Description
 */
function AddUserController(
  $state,
  $rootScope,
  Collector,
  Association,
  Operators,
  Artists,
  NOTIFICATIONS,
  Notification,
  InvitationFactory,
  moment,
  AlertMessages,
  Session
) {
  let vm = this;

  // Public Functions
  vm.searchCollectors = searchCollectors;
  vm.selectCollector = selectCollector;
  vm.createCollector = createCollector;
  vm.createAssociation = createAssociation;
  vm.startOver = startOver;

  // Public Variables
  vm.session = Session;
  vm.collectors = [];
  vm.selectedCollector = {};
  vm.newCollector = {};
  vm.association = {
    startDatetime: moment()
      .startOf('day')
      .toDate(),
    can_update_appts: true
  };

  // Private variables
  let startingRoute = $state.current.data.startingRoute[0];

  /**
   * @name searchCollectors
   * @description Search for an artist by searching collector object phone and email fields
   * @param {type} query Description
   * @param {type} type Description
   * @param {type} nextRoute Description
   */
  function searchCollectors(query, type, nextRoute) {
    let searchFields = 'phone,email';
    Collector.searchCollectors(query, searchFields).then(function(collectors) {
      vm.collectors = collectors;

      if (type === 'artist') {
        Artists.refreshArtists().then(function(artists) {
          Association.determineAssociationConflict(vm.collectors, artists);
          $state.go(nextRoute);
        });
      } else {
        Operators.getAllForShop().then(function(operators) {
          Association.determineAssociationConflict(vm.collectors, operators);
          $state.go(nextRoute);
        });
      }
    });
  }

  /**
   * @name createCollector
   * @description Create a collector
   * @param {type} nextRoute Description
   */
  function createCollector(nextRoute) {
    Collector.createCollector(vm.newCollector).then(function(collector) {
      let id = collector.id;
      Collector.getCollector(id).then(function(collector) {
        vm.selectedCollector = collector;
        $state.go(nextRoute);
      });
    });
  }

  /**
   * @name selectCollector
   * @description Select a Collector
   * @param {type} collector Description
   * @param {type} nextRoute Description
   */
  function selectCollector(collector, nextRoute) {
    if (!collector.inviteStatus) {
      vm.selectedCollector = collector;
      $state.go(nextRoute);
    }
  }

  /**
   * @name createAssociation
   * @description Create an association
   * @param {type} type Description
   * @param {type} nextRoute Description
   */
  function createAssociation(type, nextRoute) {
    // Set the notification object
    let _association = {
      collector_id: vm.selectedCollector.id,
      shop_id: Session.activeState.association.shop.id,
      status: 'Shop Invited',
      startDatetime: vm.association.startDatetime,
      endDatetime: vm.association.endDatetime,
      can_update_appts: vm.association.can_update_appts,
      operatorAdmin: vm.association.operatorAdmin,
      operatorOwner: vm.association.operatorOwner
    };

    /**
     * @name createInvitation
     * @description Define the function to create invitations and define the invitation object
     * @param {type} association Description
     * @return {type} Description
     */
    function createInvitation(association) {
      vm.newAssociation = association;
      let invitation = {
        collectorId: association.collector.id,
        shopId: association.shop.id,
        associationId: association.id
      };
      return InvitationFactory.createInvitation(invitation);
    }

    /**
     * @name sendNotification
     * @description Define the function to send notifications and define the notification object
     * @param {type} invitation Description
     */
    function sendNotification(invitation) {
      let _collectorType = invitation.association.type.toLowerCase();
      let _notificationType = _collectorType + 'Invite';
      let notification = {
        recipients: [vm.selectedCollector.id],
        notificationId: NOTIFICATIONS[_notificationType],
        messageObjects: {
          shopId: Session.activeState.association.shop.id,
          invitationId: invitation.id
        },
        messageVariables: {
          subject:
            vm.selectedCollector.first_name +
            ', you’re invited to join ' +
            Session.activeState.association.shop.name
        }
      };
      Notification.send(notification);
    }

    /**
     * @name wrapUp
     * @description Wrapup the create association function and send the user to
     * the complete route
     */
    function wrapUp() {
      $state.go(nextRoute);
    }

    // Chain the creation of associations, invitations, and notifications
    Association.createAssociation(type, _association)
      .then(createInvitation)
      .then(sendNotification)
      .then(wrapUp)
      .catch(function(error) {
        // Delete the association if an invitation could not be created
        Association.deleteAssociation(vm.newAssociation);
        AlertMessages.add({
          msg:
            'We tried to save this invitation, but something failed. Please try again.',
          type: 'danger'
        });
        startOver();
      });
  }

  /**
   * @name startOver
   * @description Reset any data retrieved or saved in the add artist workflow
   */
  function startOver() {
    $state.go(startingRoute);
    vm.collectors = [];
    vm.selectedCollector = {};
    vm.newCollector = {};
  }

  // Return to search/add if a collector hasn't been selected anywhere in the process
  if (!vm.selectedCollector.length) {
    startOver();
  }
}

angular.module('inkfinder').controller('AddUserController', AddUserController);



// WEBPACK FOOTER //
// ./components/artists/add/add-user.controller.js